import {css} from 'lit';

export const tagStyle = css`

    :host {
        --tag__bg-color: var(--_tag__bg-color, var(--sbkTagColorBgColorOnLightNeutral));
        --tag__bg-color-muted: var(--_tag__bg-color-muted, var(--sbkTagColorBgColorOnLightMuted));
        --tag__fgColor-enabled: var(--_tag__fgColor-enabled, var(--sbkTagColorFgColorOnLightEnabled));
        --tag__fgColor-hover: var(--_tag__fgColor-hover, var(--sbkTagColorFgColorOnLightHover));
        --tag__fgColor-active: var(--_tag__fgColor-active, var(--sbkTagColorFgColorOnLightActive));
        --tag__fgColor-selected: var(--_tag__fgColor-selected, var(--sbkTagColorFgColorOnLightSelected));
        --tag__border-focus: var(--_tag__border-focus, var(--sbkTagBorderOnLightFocus));
    }

    .tag__wrapper {
        max-width: fit-content;
    }

    a {
        display: flex;
        color: var(--tag__fgColor-enabled);
        font: var(--sbkTagTypographyBodyUnderlined);
        background-color: var(--tag__bg-color);
        padding: var(--sbkTagSpacingInsetTopNoCloseButton) var(--sbkTagSpacingInsetRight) var(--sbkTagSpacingInsetBottomNoCloseButton) var(--sbkTagSpacingInsetLeft);
        border-radius: var(--sbkTagBorderRadiusDefault);
        white-space: nowrap;

        &:hover {
            color: var(--tag__fgColor-hover);
        }

        &:active {
            color: var(--tag__fgColor-active);
        }

        &:focus {
            border: var(--tag__border-focus);
        }
    }

    .muted {
        background-color: var(--tag__bg-color-muted);
    }

    sbk-round-button {
        margin-left: var(--sbkTagSpacingInsetTopWithCloseButton);
    }

`
